import { config, handleResponse } from '../../_helpers';

export const areaServices = {
    getAreas,
    getAreaById,
    createArea,
    updateArea,
    deleteAreas,
    activation,
    getActiveAreas,
    getActiveAreasWithBranch,
    getOriginDestinationAreasLoad
};

function getAreas(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/areas/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/areas/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getAreaById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/areas/get/${id}`, requestOptions).then(handleResponse);
}
function createArea(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/areas`, requestOptions).then(handleResponse);
}
function updateArea(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/areas/update/${id}`, requestOptions).then(handleResponse);
}
function deleteAreas(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/areas/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/areas/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getActiveAreas() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/areas/getIsActive`, requestOptions).then(handleResponse);
}
function getActiveAreasWithBranch(branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/areas/getIsActiveAreas?BranchCode=${branchCode}`, requestOptions).then(handleResponse);
}
function getOriginDestinationAreasLoad(skip, take, branchCode, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/areas/Load?skip=${skip}&take=${take}&filter=IsActive&search=${search}&branchCode=${branchCode}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/areas/Load?skip=${skip}&take=${take}&filter=IsActive&branchCode=${branchCode}`, requestOptions).then(handleResponse);
    }
}